<div fxLayout="row wrap">
    <mat-card class="oh text-center little-profile">
        <img mat-card-image src="assets/images/background/profile-bg.jpg" alt="Photo of a Shiba Inu">
        <mat-card-content>
            <div class="pro-img">
                <img [src]="imgSrc" width="100" alt="user" class="img-circle">
            </div>
            <h3 class="m-b-0">{{ name }}</h3>
            <h6 class="m-t-0 ">{{ nip }}</h6>
        </mat-card-content>
    </mat-card>
</div>
<div fxLayout="row wrap">
    <div fxFlex.gt-lg="20" fxFlex.gt-md="20" fxFlex.gt-xs="100" fxFlex="100" *ngFor="let menu of menus">
        <mat-card [routerLink]="'/riwayat/'+id+'/'+menu.path" class="cursor-pointer">
            <mat-card-content style="padding: 24px;">
                <mat-card-title>{{ menu.label }}</mat-card-title>
            </mat-card-content>
        </mat-card>
    </div>
</div>